import { useSearchParams } from 'next/navigation'

import { useGlobalConfigContext } from '../../../global-config/context/globalConfigContext'
import { TENANT } from '../../../tenant/tenantTypes'

export const useRemovePackagesForExpaExperimentIsExpaPresentInUrl =
  (): boolean => {
    const searchParams = useSearchParams()
    const { tenant } = useGlobalConfigContext()
    const expaValue = searchParams.get('expa')

    const getExpasToDisplaySingleVariant = (): string[] => {
      switch (tenant) {
        case TENANT.AT: {
          return [
            'gglp',
            'apo',
            'med',
            'bil',
            'kel',
            'pre',
            'lad',
            'gue',
            's24',
            'ads',
            'sho',
            'doo',
            'con',
            'shof',
            'sty',
            'c24',
            'def1',
            'def2',
            'def3',
            'shp',
            'ide',
            'gei',
          ]
        }
        case TENANT.CH: {
          return [
            'shof',
            'pre',
            'ads',
            'kel',
            'bil',
            'shop',
            'com',
            'gue',
            'doo',
            'de1',
            'de2',
            'de3',
            'gglp',
            'ovtp',
          ]
        }
        default: {
          return []
        }
      }
    }

    const expasToDisplaySingleVariant = getExpasToDisplaySingleVariant()

    return expaValue !== null && expasToDisplaySingleVariant.includes(expaValue)
  }
